import { Typography, useTheme } from '@material-ui/core';
import React from 'react';

const MIN_WIDTH = '250px';

const DEFAULT_SIZING: React.CSSProperties = {
  width: '300px',
  maxWidth: '35vw',
  minWidth: MIN_WIDTH,
};

interface SidePanelProps {
  title?: string;
  width?: string;
  children: React.ReactNode;
}

export const SidePanel: React.FC<SidePanelProps> = ({ title, width, children }) => {
  const theme = useTheme();
  return (
    <div style={{
      ...(width ? { width, minWidth: MIN_WIDTH } : DEFAULT_SIZING),
      flex: '0 0 auto',
      minHeight: 0,
      background: theme.palette.storageUi.backgroundSecondary,
      color: theme.palette.secondary.main,
      padding: '15px',
      borderLeft: `3px solid ${theme.palette.secondary.main}`,
      overflowY: 'auto',
      fontSize: '12px',
      boxShadow: '-5px 0 15px rgba(0, 0, 0, 0.5)'
    }}>
      {title && (
        <Typography variant="h6" style={{ marginBottom: '12px', color: 'inherit' }}>
          {title}
        </Typography>
      )}
      {children}
    </div>
  );
};
